$(document).ready(function(){
  $('.btn-event-attendee-info').click(function() {
    var index = $("input[name=set_default]:checked").data('index');
    var set_default = `<input type="hidden" value='true' name='event_attendee_info[attendee_info_options_attributes][${index}][set_default]' id="set_default_attendee_info_option">`
    $('#append_set_default').html(set_default);
  });

  setDefaultOption();

  $('.add_fields').click(function() {
    setDefaultOption();
  });

  function setDefaultOption(){
    $(".remove_fields").click(function(){
      var field_idx = $(this).attr("data-field-idx");

      $(`#option-${field_idx}`).attr("checked", false);
    });
  }
});